import React, { useState } from 'react';
import './blogSection.scss';
import BlogItemComponent from "./components/BlogItemComponent";
import { useNavigate } from "react-router";
import { blogData } from '../../../blog/sections/blogListSection/BlogListSection';

const BlogSection = () => {
	const navigate = useNavigate();
	const [currentIndex, setCurrentIndex] = useState(0);

	const entries = Object.entries(blogData.slice(0, 3));
	const n = entries.length;

	const handleClick = (increment: number) => {
		setCurrentIndex((prevIndex) => (prevIndex + increment + n) % n);
	};


	return (
		<div className="blogSection">
			<div className="blogSection__title">
				<h2>Blog</h2>
				<button
					className="secondButton"
					onClick={() => navigate('/blog')}
				>
					<span>View blog</span>
				</button>
			</div>
			<div className="blogSection__content">
				{entries.map(([key, value], index) => (
					<BlogItemComponent
						key={`${key}-${index}-${value.date}`}
						image={<img src={value.image} alt={value.text} style={{ objectPosition: `${value.href === 'proxies' && "-10px"}` }} />}
						text={value.text}
						date={value.date}
						id={value.id}
						index={currentIndex}
						setIndex={handleClick}
						href={value.href}
					/>
				))
				}
			</div>

			<div className="blogSection__contentAdaptive">
				{entries.map(([key, value], index) => (
					<BlogItemComponent
						key={`${key}-${index}-${value.date}`}
						image={<img src={value.image} alt={value.text} style={{ objectPosition: `${value.href === 'proxies' && "-10px"}` }} />}
						text={value.text}
						date={value.date}
						id={value.id}
						index={currentIndex}
						setIndex={handleClick}
						href={value.href}

					/>
				))
				}
				<div className="slideItemComponent__buttons">
					<button
						disabled={currentIndex === 0}
						className={`${currentIndex === 0 && 'disabled'}`}
						onClick={() => handleClick(-1)}
					>
						<svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
							<path d="M15.0751 9.49915C15.6274 9.49915 16.0751 9.05143 16.0751 8.49915C16.0751 7.94686 15.6274 7.49914 15.0751 7.49915L15.0751 9.49915ZM1.91313 7.79204C1.52261 8.18256 1.52261 8.81573 1.91313 9.20625L8.27709 15.5702C8.66762 15.9607 9.30078 15.9607 9.69131 15.5702C10.0818 15.1797 10.0818 14.5465 9.69131 14.156L4.03445 8.49915L9.69131 2.84229C10.0818 2.45177 10.0818 1.8186 9.69131 1.42808C9.30078 1.03755 8.66762 1.03755 8.27709 1.42808L1.91313 7.79204ZM15.0751 7.49915H2.62024L2.62024 9.49915H15.0751L15.0751 7.49915Z" fill="#5E41CE" />
						</svg>
					</button>
					<div className="slideItemComponent__buttons_indexes">
						{
							Array.from({ length: entries.length }).map((_: any, index: number) => (
								<svg key={`btn index - ${index}`} className={`slideItemComponent__buttons_indexes_item ${index ===
									currentIndex ? 'active' : ''}`}
									xmlns="http://www.w3.org/2000/svg"
									width="9"
									height="9"
									viewBox="0 0 9 9"
									fill="none"
								>
									<circle cx="4.34766" cy="4.5" r="4" fill={`#fff`} />
								</svg>
							))
						}
					</div>
					<button
						disabled={currentIndex === entries.length - 1}
						className={`${currentIndex === entries.length - 1 && 'disabled'}`}
						onClick={() => handleClick(1)}
					>
						<svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
							<path d="M2.62024 7.50085C2.06795 7.50085 1.62024 7.94857 1.62024 8.50085C1.62024 9.05314 2.06795 9.50086 2.62024 9.50085L2.62024 7.50085ZM15.7822 9.20796C16.1727 8.81744 16.1727 8.18427 15.7822 7.79375L9.41822 1.42979C9.0277 1.03926 8.39453 1.03926 8.00401 1.42979C7.61348 1.82031 7.61348 2.45348 8.00401 2.844L13.6609 8.50085L8.00401 14.1577C7.61348 14.5482 7.61348 15.1814 8.00401 15.5719C8.39453 15.9624 9.02769 15.9624 9.41822 15.5719L15.7822 9.20796ZM2.62024 9.50085H15.0751L15.0751 7.50085H2.62024L2.62024 9.50085Z" fill="#5E41CE" />
						</svg>
					</button>
				</div>
				<div className="blogSection__contentAdaptive_btn">
					<button
						className="secondButton"
						onClick={() => navigate('/blog')}
					>
						<span>View blog</span>
					</button>
				</div>
			</div>
		</div>
	);
};

export default BlogSection;